import { Navbar1 } from "components/navbars";
import Company from "crm/other/Company";
import { Footer1 } from "components/footer";
import Seo from "components/Seo";
import BackToTop from "components/BackToTop";
import { usePageTracking } from "helpers/usePageTracking";

export default function About() {
    const seo = usePageTracking("about");
    return (
        <>
            {seo && (
                <Seo
                    pageName="about"
                    title={seo.pageTitle}
                    description={seo.seoMetaDescription}
                    keywords={seo.seoMetaKeywords}
                    url="https://www.salestrackify.com/about"
                    image="/seo/trackify-preview.png"
                />
            )}

            <Navbar1
                hideSearch
                fixedWidth
                navClass="navbar-light zindex-10"
                buttonClass="btn-outline-secondary btn-sm"
            />
            <Company />

            <Footer1 />
            {/* <BackToTop /> */}
        </>
    );
}
